module.exports = __webpack_public_path__ + "static/media/profundidad.c3a85ef7.png";